module.exports = __webpack_public_path__ + "static/media/maal-m.3a2b868f.mp3";